import { Btn, I, IconBtn } from "./ui";

export type ThemeMode = "dark" | "light";

export interface TweakState {
  mode: ThemeMode;
}

export function Tweaks({
  tweaks,
  setTweaks,
  onClose,
}: {
  tweaks: TweakState;
  setTweaks: (t: TweakState) => void;
  onClose: () => void;
}) {
  return (
    <div className="tweaks-panel">
      <div className="tweaks-head">
        {I.sliders}
        <strong style={{ flex: 1, fontSize: 13 }}>Aspetto</strong>
        <IconBtn icon={I.x} onClick={onClose} />
      </div>
      <div className="tweaks-body">
        <div className="tweak-row tweak-row-stack">
          <span className="lbl">Tema</span>
          <div className="theme-switch">
            <Btn
              size="sm"
              variant={tweaks.mode === "dark" ? "primary" : ""}
              onClick={() => setTweaks({ ...tweaks, mode: "dark" })}
            >
              Scuro
            </Btn>
            <Btn
              size="sm"
              variant={tweaks.mode === "light" ? "primary" : ""}
              onClick={() => setTweaks({ ...tweaks, mode: "light" })}
            >
              Chiaro
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
}
